<template>
    <div style="display:grid; gap:15px">
        <h3>Seguimiento SMS</h3>
        <div style="display:flex; gap:50px">
            <div style="display:flex; gap:25px">
                <label for="">Saldo actual:</label>
                <p>{{ saldo }} créditos</p>
            </div>
            <div style="display:flex; gap:25px; align-items:center">
                <label for="">Obtener créditos:</label>
                <button class="btn btn-primary btn-sm" @click="obtenerCreditos">Obtener</button>
            </div>
        </div>
        <div style="display:flex; gap:15px">
            <label for="">Usuario:</label>
            <select v-model="usuario_seleccionado" class="form-control form-control-sm" style="width:200px">
                <option value="">---</option>
                <option v-for="usuario in usuarios" :key="usuario.idusuario" :value="usuario.nombre">{{ usuario.nombre }}</option>
            </select>
            <button class="btn btn-primary btn-sm" @click="obtenerListado">Buscar</button>
        </div>
        <tabla-datos :botoncrear="1" @quieroDatos="obtenerListado($event);" :total="total" :columnas="columnas" 
        :datos="expedientes" :filtros="false">
        </tabla-datos>
    </div>
</template>
<script>
import TablaDatos from '../TablaDatos.vue';
import { PwgsApi } from '../../services/PwgsApi';
export default {
    props:[],
    components:{
        "tabla-datos": TablaDatos,
    },
    data(){
        return{
            saldo:0,
            url_global: localStorage.getItem('direccion'),
            expedientes: [],
            total:0,
            usuario_seleccionado: '',
            usuarios:[],
            columnas: [
                {
                    header: 'Fecha de envío',
                    field: 'fecha_envio',
                },
                {
                    header: 'Número',
                    field: 'numero_sms',
                },
                {
                    header: 'Usuario',
                    field: 'usuario_sms',
                },
                {
                    header: 'texto',
                    field: 'texto_sms',
                },
                {
                    header: 'Diferido',
                    field: 'diferido',
                }
            ]
        }
    },
    methods:{
        cargarDatos(){
            this.consultarCreditos();
            this.cargarUsuarios();
            this.obtenerListado();
        },
        async consultarCreditos(){
            const api = new PwgsApi();
            const response = await api.get('sms-pwgs/creditos');
            this.saldo = response.creditos;
        },
        obtenerCreditos(){
            window.open("http://apuyen.com", '_blank');
        },
        async obtenerListado(event){
            const api = new PwgsApi();
            if(!event) event = {};
            if(!event.rows){
                event.rows = 15;
                event.page = 0;
            }
            event.usuario = this.usuario_seleccionado;
            const resp = await api.post('seguimiento-sms',event);
            resp.datos.forEach(element => {
                element.fecha_envio = this.formatearFecha(element.fecha_sms);
                element.diferido = this.formatearFecha(element.diferido_sms);
            })
            this.expedientes = resp.datos;
            this.total = resp.n_total_registros;
            console.log(this.expedientes);
        },
        formatearFecha(fecha){
            if(!fecha) return '';
            console.log('fecha',fecha);
            let aux = new Date(parseInt(fecha));
            console.log('aux',aux);
            let dia = aux.getDate();
            let mes = aux.getMonth() + 1;
            let anio = aux.getFullYear();
            let hora = aux.getHours();
            let minutos = aux.getMinutes();
            return dia + '/' + mes + '/' + anio + ' ' + hora + ':' + minutos;
        },
        async cargarUsuarios() {
            const api = new PwgsApi();
            const resp = await api.get('/usuarios/usuarios,simple');
            this.usuarios = resp.datos;
        },
    },
    mounted(){
        this.cargarDatos();
    }
}

</script>
